// Phase 3.2b — Cycle Count detail top submenu.
//
// UI-only migration: antd Button/Radio/Divider/Row/Col → shadcn Button +
// segmented toggle buttons + Separator. Every hook, effect and dispatch is the
// legacy one; the Single/Multiple switch, Pending/Completed toggle and
// OnHold/InProgress/Completed status actions all fire the same handlers/payloads.
// The Single/Multiple selection (previously antd Radio defaultValue) is tracked
// in a local `singleSel` state so the active button highlights.
import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { createOrUpdateCycleCountAction } from "../../Store/actions/apparelAction";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "ui/button";
import { Separator } from "ui/separator";
import { cn } from "lib/utils";


interface propType {
  searchTextApi: any,
  setSingle: any,
  data: any,
  setPendingButton: any,
  setStatusRefIdOnClick: any,
  setCountIndex: any,
  setProductCategoryMappingId: any
}

const IndividualCycleIdSubmenu = (props: propType) => {
  const dispatch = useDispatch()
  const { searchTextApi,
    setSingle,
    data,
    setPendingButton,
    setStatusRefIdOnClick,
    setCountIndex,
    setProductCategoryMappingId } = props;
  const ApparelReducerState = useSelector((state: any) => state.ApparelReducerState);
  const { getMultipleCategoryListData,
    createOrUpdateCycleCountLoad } = ApparelReducerState;
  const getCategory = getMultipleCategoryListData?.getCategorySubcategoryList?.ispendingEmpty;
  const getcategorycompleted = getMultipleCategoryListData?.getCategorySubcategoryList?.iscatagoryCompleted
  const locationProps = useLocation().state;
  const navigate = useNavigate()
  const [button, setButton] = useState(1)
  const [singleSel, setSingleSel] = useState(1)
  const [footerChangerButton, setFooterChangerButton] = useState(false)
  const [getButtonChanger, setGetButtonChanger] = useState(false)
  const [markCompleted, setMarkCompleted] = useState(false);
  const [completeOnload, setCompleteOnload] = useState(false);
  const [completed, setCompleted] = useState(false)

  const buttonChanger = (value: any) => {
    setGetButtonChanger(false)
    setButton(value)
    setCountIndex(0)
    setPendingButton(value)
    setGetButtonChanger(true)
    setProductCategoryMappingId("");
    { value === 2 ? (setStatusRefIdOnClick(2)) : (setStatusRefIdOnClick(null)) }
  }

  const footerChanger = (foot: any) => {
    setSingleSel(foot)
    setCountIndex(0)
    setSingle(foot);
    setButton(1)
    setPendingButton(1)
    setFooterChangerButton(true);
    setProductCategoryMappingId("");
  }

  const statusRefHandler = (id: any) => {
    setCompleted(true)
    let payload = {
      cycleCountJobId: data?.data?.cycleCountJobId,
      name: data?.data?.name,
      statusRefId: id
    }
    dispatch(createOrUpdateCycleCountAction(payload));
    setCompleteOnload(true);
  }

  useEffect(() => {
    if (completeOnload && !createOrUpdateCycleCountLoad) {
      setCompleteOnload(false);
      navigate('/cycle/count')
    }
  }, [completeOnload, createOrUpdateCycleCountLoad])

  useEffect(() => {
    if (footerChangerButton) {
      searchTextApi()
      setFooterChangerButton(false)
      setStatusRefIdOnClick(null)

    }
  }, [footerChangerButton])

  useEffect(() => {
    if (getButtonChanger) {
      searchTextApi()
      setGetButtonChanger(false)

    }
  }, [getButtonChanger])


  useEffect(() => {
    if (getCategory == 1) {
      setMarkCompleted(false)
    }
    else {
      setMarkCompleted(true)
    }
  }, [getCategory])

  // Single/Multiple segmented toggle. When a category is complete the legacy
  // showed a tick badge on each option (getCategory !== 0 && not-completed view).
  const showTick = locationProps?.data?.statusRefId != 3 && getCategory !== 0;
  const SingleMultiple = () => (
    <div className="inline-flex overflow-hidden rounded-md border">
      <button
        type="button"
        onClick={() => footerChanger(1)}
        className={cn(
          "flex items-center gap-1.5 px-4 py-1.5 text-sm font-medium",
          singleSel === 1 ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted"
        )}
      >
        Single {showTick && <Check className="h-3.5 w-3.5" />}
      </button>
      <button
        type="button"
        onClick={() => footerChanger(0)}
        className={cn(
          "flex items-center gap-1.5 border-l px-4 py-1.5 text-sm font-medium",
          singleSel === 0 ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted"
        )}
      >
        Multiple {showTick && <Check className="h-3.5 w-3.5" />}
      </button>
    </div>
  );

  const submenu = () => {
    return (
      <div className="mz px-4 py-3">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-1 text-base font-semibold">
            <span>Cycle Count-</span>
            <span>{locationProps?.data?.cycleCountId}</span>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <SingleMultiple />
            <div>
              {
                locationProps?.data?.statusRefId != 3 && locationProps?.data?.statusRefId != 4
                  ?
                  <Button variant="outline" onClick={() => statusRefHandler(4)}>Mark As OnHold</Button>
                  : locationProps?.data?.statusRefId == 4 ?
                    <Button variant="outline" onClick={() => statusRefHandler(2)}>Move to InProgress</Button>
                    :
                    ""
              }
            </div>

            <div>
              {
                locationProps?.data?.statusRefId != 3 && locationProps?.data?.statusRefId != 4 ?
                  <Button
                    disabled={getcategorycompleted == 1 ? true : false}
                    onClick={() => statusRefHandler(3)}>Mark As Completed</Button>
                  :
                  ""
              }
            </div>
          </div>
        </div>

        {
          locationProps?.data?.statusRefId != 3 ?
            <div>
              <Separator className="my-3" />
              <div className="inline-flex overflow-hidden rounded-md border">
                <button
                  type="button"
                  className={cn(
                    "px-4 py-1.5 text-sm font-medium",
                    button == 1 ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted"
                  )}
                  onClick={() => buttonChanger(1)} >Pending</button>
                <button
                  type="button"
                  className={cn(
                    "border-l px-4 py-1.5 text-sm font-medium",
                    button == 2 ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted"
                  )}
                  onClick={() => buttonChanger(2)} >Completed</button>
              </div>
            </div>
            :
            ""
        }
      </div>
    )
  }
  return (

    <div>
      {submenu()}
    </div>
  )
}

export default IndividualCycleIdSubmenu
